import request from "@/utils/request.util";
import qs from "qs";

export const getListAllotment = async (payload) => {
  const params = {
    params: payload,
  };
  return request.get("inventories", params);
};

export const getMergeAllotment = async (payload) => {
  const params = {
    type: payload.type,
    time: payload.time,
  };
  const query = `${qs.stringify(params)}`;
  return request.get("inventories/all_branches.json?" + query);
};

export const createAllotment = async (payload) => {
  return request.post("inventories", payload);
};

export const updateAllotment = async (payload) => {
  return request.put("inventories/update_inventory", payload);
};

export const getAllotmentDetail = async ({ id, restaurantId }) => {
  const params = {
    restaurant_id: restaurantId,
  };
  const query = `${qs.stringify(params)}`;
  return request.get(`inventories/${id}?${query}`);
};

export const updateAllotmentDetail = async (payload) => {
  return request.put("inventories/update_inventory_detail", payload);
};

export const blockAllotment = async (payload) => {
  return request.post("inventories/block", payload);
};

export const getListAllotmentSetter = async (payload) => {
  const query = `${qs.stringify(payload)}`;
  return request.get(`inventories/edit_inventory?${query}`);
};

export const unBlockAllotment = async (payload) => {
  const params = {
    params: payload,
  };
  return request.get("inventories/undo", params);
};

export const getListHistoryAllotment = async (payload) => {
  const params = {
    params: payload,
  };
  return request.get("/inventories/history", params);
};

export const getListBlockRequest = async (payload) => {
  const params = {
    params: payload,
  };
  return request.get("block_requests", params);
};

export const requestBlockAllotment = async (payload) => {
  return request.post("block_requests", payload);
};

export const getBlockRequestDetail = async (id) => {
  return request.get(`block_requests/${id}`);
};

export const withdrawBlockRequest = async (id) => {
  return request.patch(`block_requests/${id}/withdraw`);
};
